import { Link } from 'react-router-dom';
import { aboutInfo, testimonials, faqList } from '@/mocks/anime';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'AboutPage',
        name: '关于91动漫 - 正版高清动漫在线观看平台',
        description: '91动漫是深受动漫迷喜爱的在线动漫平台，提供海量高清正版动漫资源。了解91动漫的品牌故事、口碑评价和联系方式。',
        url: 'https://www.91anime.com/about',
        isPartOf: { '@id': 'https://www.91anime.com/#website' },
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqList.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于91动漫 - 品牌介绍、口碑评价与联系方式"
        description="了解91动漫的品牌故事与发展历程。91动漫是深受动漫迷喜爱的在线动漫平台，提供海量高清正版动漫资源。查看用户口碑评价与联系方式。"
        keywords="91动漫,关于91动漫,91动漫品牌介绍,动漫平台介绍,91动漫联系方式,动漫网站口碑"
        canonicalUrl="https://www.91anime.com/about"
        structuredData={structuredData}
      />

      <Navbar />

      <main>
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full py-12 md:py-16 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center bg-primary-500 rounded-2xl">
              <i className="ri-play-circle-fill text-3xl text-white"></i>
            </div>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
              {aboutInfo.slogan}
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              {aboutInfo.introduction}
            </p>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-14">
              {aboutInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center p-5 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-1">{stat.value}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="mb-14">
              <h2 className="text-2xl font-heading font-bold text-foreground-950 mb-4">品牌故事</h2>
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {aboutInfo.introduction}
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {aboutInfo.mission}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                用户口碑
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                动漫迷的真实评价
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <div key={t.id} className="bg-background-50 rounded-xl p-5 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(t.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">&ldquo;{t.content}&rdquo;</p>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                    </div>
                    <span className="text-sm font-medium text-foreground-900">{t.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
                联系我们
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                期待你的声音
              </h2>
              <p className="text-sm text-foreground-500 mt-2">有任何建议或合作意向，欢迎通过以下方式联系我们</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-500 break-all">{aboutInfo.contact.email}</p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className="ri-weibo-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">官方微博</h3>
                <p className="text-xs text-foreground-500">{aboutInfo.contact.weibo}</p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
                <p className="text-xs text-foreground-500">{aboutInfo.contact.wechat}</p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
                <p className="text-xs text-foreground-500">{aboutInfo.contact.address}</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}